var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.44,
    height: 29.943,
    viewBox: "0 0 31.44 29.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M9.486,3H24.457c4.491,0,7.486,2.246,7.486,7.486v4.7a1.5,1.5,0,0,1-2.126,1.347,9.72,9.72,0,0,0-13.4,6.962,9.893,9.893,0,0,0-.1,3.309,1.487,1.487,0,0,1-1.482,1.662H9.486C4.994,28.467,2,26.221,2,20.981V10.5C2,5.246,4.994,3,9.486,3Z",
    transform: "translate(0 0)",
    fill: "#14294a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M14.861,14.17a5.566,5.566,0,0,1-3.5-1.183L6.671,9.244A1.119,1.119,0,0,1,8.064,7.492l4.686,3.743a3.572,3.572,0,0,0,4.207,0l4.686-3.743a1.119,1.119,0,0,1,1.392,1.752l-4.686,3.743A5.494,5.494,0,0,1,14.861,14.17Z",
    transform: "translate(2.112 2.11)",
    fill: "#14294a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M20.486,13a7.486,7.486,0,1,0,7.486,7.486A7.479,7.479,0,0,0,20.486,13Zm3.069,6.812L23,20.351l-3.249,3.264a1.443,1.443,0,0,1-.644.314l-1.467.21a.693.693,0,0,1-.823-.823l.21-1.467a1.3,1.3,0,0,1,.314-.644l3.264-3.249.539-.554a1.745,1.745,0,0,1,1.183-.6,1.773,1.773,0,0,1,1.213.6A1.478,1.478,0,0,1,23.555,19.812Z",
    transform: "translate(5.469 4.972)",
    fill: "#14294a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9397cf97a8c2d7bfbf4fb3c58e2eea6e.svg";
export { ForwardRef as ReactComponent };